"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoResults = NoResults;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/styles");
var _PackageVariant = _interopRequireDefault(require("mdi-material-ui/PackageVariant"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    noResultsContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: theme.spacing(4),
      '& h4': {
        color: theme.palette.NEUTRAL700,
        fontWeight: 700,
        lineHeight: theme.typography.pxToRem(24),
        margin: 0,
        marginBottom: theme.spacing(0.5)
      },
      '& p': {
        color: theme.palette.NEUTRAL700,
        fontWeight: 400,
        lineHeight: theme.typography.pxToRem(24),
        margin: 0
      }
    },
    noResultsIcon: {
      color: theme.palette.NEUTRAL050,
      fontSize: theme.typography.pxToRem(28),
      marginBottom: theme.spacing(1)
    }
  };
});
function NoResults() {
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.noResultsContainer
  }, /*#__PURE__*/_react.default.createElement(_PackageVariant.default, {
    className: classes.noResultsIcon
  }), /*#__PURE__*/_react.default.createElement("h4", null, "No results found"), /*#__PURE__*/_react.default.createElement("p", null, "Please try again"));
}